import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-loader, myt-app-action-loader',
  templateUrl: './app-action-loader.component.html',
  styleUrls: ['./app-action-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppActionLoaderComponent {
  @Input() active = false;
  @Input() idleLabel = 'Submit';
  @Input() loadingLabel?: string;
  @Input() disabledWhenActive = true;
  @Input() showSpinner = true;
  @Input() ariaLabel?: string;

  get resolvedLabel(): string {
    if (this.active) {
      return this.loadingLabel || this.idleLabel;
    }

    return this.idleLabel;
  }

  get resolvedAriaLabel(): string {
    return this.ariaLabel || this.resolvedLabel;
  }

  get disabledState(): boolean {
    return this.active && this.disabledWhenActive;
  }
}
